import { Input } from "../ui/input";

const UK = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
export const isoToUk = (v) => { const m = String(v || "").match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? `${m[3]}/${m[2]}/${m[1]}` : (v || ""); };
export const ukValid = (v) => !v || UK.test(v.trim());

// DD/MM/YYYY text input — the server parses UK dates directly.
export function UkDateInput({ value, onChange, testid, ...rest }) {
  const bad = !ukValid(value);
  return (
    <div>
      <Input data-testid={testid} inputMode="numeric" placeholder="DD/MM/YYYY" value={value || ""} onChange={(e) => onChange(e.target.value)}
        className={`mt-1 ${bad ? "border-red-400" : ""}`} {...rest} />
      {bad && <span className="text-[11px] text-red-600">Use DD/MM/YYYY</span>}
    </div>
  );
}
